import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
